import * as v from "valibot";
import { rpcContract } from "../rpc";

export const getLiveEventsRpcContract = rpcContract({
  name: "get-live-events",
  paramsSchema: v.object({
    status: v.optional(v.picklist(["draft", "scheduled", "live", "ended", "cancelled", "archived"])),
  }),
  resultSchema: v.object({
    events: v.array(
      v.object({
        id: v.string(),
        title: v.string(),
        description: v.nullable(v.string()),
        content_tier: v.string(),
        fee_cents: v.nullable(v.number()),
        status: v.string(),
        scheduled_start_time: v.nullable(v.string()),
        actual_start_time: v.nullable(v.string()),
        end_time: v.nullable(v.string()),
        max_attendees: v.nullable(v.number()),
        thumbnail_url: v.nullable(v.string()),
        thumbnail_path: v.nullable(v.string()),
        thumbnail_file_id: v.nullable(v.string()),
        peak_viewer_count: v.number(),
        created_at: v.string(),
        updated_at: v.string(),
        language: v.optional(v.nullable(v.string())),
        stream_delivery: v.optional(v.string()),
        tickets_sold: v.number(),
        revenue_cents: v.number(),
        recording_status: v.optional(v.nullable(v.string())),
        recording_url: v.optional(v.nullable(v.string())),
        community_only: v.boolean(),
      }),
    ),
    counts: v.object({
      draft: v.number(),
      scheduled: v.number(),
      live: v.number(),
      ended: v.number(),
      archived: v.number(),
      total: v.number(),
    }),
  }),
});

export type GetLiveEventsParams = v.InferOutput<(typeof getLiveEventsRpcContract)["paramsSchema"]>;
export type GetLiveEventsResult = v.InferOutput<(typeof getLiveEventsRpcContract)["resultSchema"]>;
export type LiveEvent = GetLiveEventsResult["events"][0];
